<div class="title">
  <p>{{ "COMMON.MBC_DETAILS.MAIN_FEEDER" | translate }}</p>
  <div class="button-group">
    <button
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#addNewF33"
      (click)="addNew()"
      *ngIf="
        permissionsService.isF33CreateEditAllowed &&
        utilityId != 0 &&
        bpsAdminLevel != 2
      "
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 0C7.4477 0 7 0.44772 7 1V7H1C0.44772 7 0 7.4477 0 8C0 8.5523 0.44772 9 1 9H7V15C7 15.5523 7.4477 16 8 16C8.5523 16 9 15.5523 9 15V9H15C15.5523 9 16 8.5523 16 8C16 7.4477 15.5523 7 15 7H9V1C9 0.44772 8.5523 0 8 0Z"
          fill="white"
        />
      </svg>
      {{ "CRUD_SETTINGS.ADD_NEW" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-secondary"
      (click)="download()"
      *ngIf="permissionsService.isTsCreateEditAllowed && bpsAdminLevel != 2"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 10.5L11.5 7L10.25 5.75L9 7V3H7V7L5.75 5.75L4.5 7L8 10.5ZM2 14H14V12H2V14Z"
          fill="white"
        />
      </svg>
      {{ "CRUD_SETTINGS.DOWNLOAD" | translate }}
    </button>
  </div>
</div>
<div class="container-fluid border-bottom">
  <table>
    <tr class="header-row">
      <th>{{ "TRANSFORMERS.EDIT.33KV_FEEDER_NAME" | translate }}</th>
      <th>{{ "COMMON.MBC_DETAILS.FEEDER_NUMBER" | translate }}</th>
      <th>{{ "COMMON.TS.SINGLE" | translate }}</th>
      <th>{{ "COMMON.BU.SINGLE_OR_PLURAL" | translate }}</th>
      <th>Code</th>
      <th *ngIf="permissionsService.hasDashboardConfigFeederBands">Band</th>
      <th></th>
    </tr>
    <tr
      class="content-wrapper"
      *ngFor="let f33 of feeders33"
      data-bs-toggle="modal"
      data-bs-target="#addNewF33"
      (click)="
        permissionsService.isF33CreateEditAllowed ? selectF33(f33) : null
      "
    >
      <td>{{ f33.name | hasValue }}</td>
      <td>{{ f33.number | hasValue }}</td>
      <td>{{ f33.transmissionStation?.name | hasValue }}</td>
      <td>{{ f33.currentRegions | hasValue }}</td>
      <td>{{ f33.code | hasValue }}</td>
      <td *ngIf="permissionsService.hasDashboardConfigFeederBands">{{ f33.feederBand | hasValue }}</td>
      <td class="td-svg">
        <svg
          data-bs-toggle="modal"
          data-bs-target="#deleteF33"
          (click)="selectF33(f33)"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          xmlns="http://www.w3.org/2000/svg"
          *ngIf="permissionsService.isF33DeleteAllowed && bpsAdminLevel != 2"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z"
            fill="#DE350B"
          />
        </svg>
      </td>
    </tr>
  </table>
</div>
<div>
  <app-paging
    *ngIf="count > 0"
    [pageSize]="pageSize"
    [count]="count"
    [currentPage]="currentPage"
    (pageChange)="pageChange($event)"
  ></app-paging>
</div>

<div
  class="modal fade"
  id="addNewF33"
  tabindex="-1"
  aria-hidden="true"
  (hidden.bs.modal)="onModalFade()"
  *ngIf="permissionsService.isF33CreateEditAllowed"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ actionLabel$ | async }} {{ "COMMON.MBC_DETAILS.MAIN_FEEDER" | translate }}
        </h5>
        <button
          type="button"
          #closeAddModal
          class="btn-cancel-modal"
          data-bs-dismiss="modal"
        >
          {{ "COMMON.CANCEL" | translate }}
        </button>
      </div>
      <form
        id="addForm"
        class="form-wrapper"
        ngNativeValidate
        (submit)="save()"
      >
        <div class="modal-body">
          <div class="form-item form-floating mb-3">
            <input
              id="f33Name"
              name="name"
              type="text"
              [(ngModel)]="selectedF33.name"
              class="form-control"
              required
              placeholder=" "
            />
            <label for="f33Name">{{
              "COMMON.MBC_DETAILS.MAIN_FEEDER_NAME" | translate
            }}</label>
          </div>
          <div class="form-item form-floating mb-3">
            <input
              id="f33Number"
              name="number"
              type="text"
              [(ngModel)]="selectedF33.number"
              class="form-control"
              required
              placeholder=" "
            />
            <label for="f33Number">{{
              "COMMON.MBC_DETAILS.MAIN_FEEDER_NUMBER" | translate
            }}</label>
          </div>
          <div class="form-item form-floating mb-3">
            <div class="form-item form-floating mb-3">
                <app-dropdown-search
                  [items]="tss"
                  label="COMMON.TS.SINGLE"
                  id="transmission-station-dropdown"
                  [selectedItemId]="selectedF33.transmissionStation?.id || null"
                  [reset]="resetDropdownSearch"
                  (selectedIdChange)="onTransmissionStationIdChange($event)"
                ></app-dropdown-search>
            </div>
          </div>
          <div class="multi-select-group">
            <app-multi-select-dropdown
              [clicked]="clicked"
              [items]="regions"
              [label]="buName + 's'"
              [showMore]="false"
              [searchFilterActive]="true"
              (filterValue)="applySearchFilter($event)"
              [requireApply]="false"
              (shareCheckedList)="selectRegion($event)"
            >
            </app-multi-select-dropdown>
          </div>
          <div *ngIf="permissionsService.hasDashboardConfigFeederBands" class="form-item form-floating mb-3 mt-5">
            <input
              id="feederBand"
              name="feederBand"
              type="text"
              [(ngModel)]="selectedF33.feederBand"
              class="form-control"
              disabled
              placeholder=" "
            />
            <label for="feederBand">Band</label>
          </div>
        </div>
        <div class="modal-footer" *ngIf="bpsAdminLevel != 2">
          <button class="btn btn-primary" form="addForm">
            {{ "COMMON.SAVE" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteF33" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }}
          {{ "COMMON.MBC_DETAILS.MAIN_FEEDER" | translate }}?
        </h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="deleteFeeder()">
          {{ "COMMON.DELETE" | translate }}
        </button>
        <button
          #closeDeleteModal
          hidden="true"
          data-bs-dismiss="modal"
        ></button>
      </div>
    </div>
  </div>
</div>
